import { render, staticRenderFns } from "./SichernConnectError.vue?vue&type=template&id=8b3b3152&scoped=true"
import script from "./SichernConnectError.vue?vue&type=script&lang=js"
export * from "./SichernConnectError.vue?vue&type=script&lang=js"
import style0 from "./SichernConnectError.vue?vue&type=style&index=0&id=8b3b3152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3b3152",
  null
  
)

export default component.exports